import * as Yup from 'yup';
import {
  appStatusValidation,
  appUrlValidation,
  authorizationMethodValidation,
  debugEnabledValidation,
  externalAddressValidation,
  smsTemplateValidation
} from '../../../../../../../constants/validation';

const commonValidators = {
  appUrl: appUrlValidation,
  status: appStatusValidation,
  debugEnabled: debugEnabledValidation,
  authorizationMethod: authorizationMethodValidation,
  smsTemplate: smsTemplateValidation,
  externalAddress: externalAddressValidation
};

export const editFormValidations = Yup.object().shape(commonValidators);
